import React from 'react';
import { Box } from '@mui/material';

interface FormChipProps {
  form: string;
}

const FormChip: React.FC<FormChipProps> = ({ form }) => {
  const getFormColor = (result: string) => {
    switch (result) {
      case 'W': return '#4caf50'; // Green
      case 'D': return '#ff9800'; // Orange  
      case 'L': return '#f44336'; // Red
      default: return '#9e9e9e'; // Grey
    }
  };

  // If no form data (team hasn't played), show a single grey dash
  // Use minHeight: 28 to match the height of the last match indicator when form data exists
  if (!form || form.trim() === '') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 28 }}>
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: '50%',
            backgroundColor: '#9e9e9e',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            fontWeight: 'bold'
          }}
        >
          -
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', minHeight: 28 }}>
      {form.split('').map((result, index) => {
        const isLastMatch = index === form.length - 1;
        return (
          <Box
            key={index}
            sx={{
              width: isLastMatch ? 28 : 20,
              height: isLastMatch ? 28 : 20,
              borderRadius: '50%',
              backgroundColor: getFormColor(result),
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '10px',
              fontWeight: 'bold',
              ...(isLastMatch && {
                border: `2px solid ${getFormColor(result)}`,
                backgroundColor: 'white'
              })
            }}
          >
            <Box
              sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: getFormColor(result),
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '10px',
                fontWeight: 'bold'
              }}
            >
              {result}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default FormChip;
